import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/core/basic/Button";
import { css } from "../../../../styled-system/css";
import { successToast } from "../../../utils/toasts";
import { FaCopy } from "react-icons/fa6";
import { Flex, VStack } from "../../../../styled-system/jsx";
import _QRCode from "react-qr-code";
const QRCode = (_QRCode as unknown as { default: typeof _QRCode }).default;
import { TextField } from "../../../components/fields/base/TextField";

interface Props {
  otpauthurl: string;
  secret: string;
  digits: number;
  onCancel: () => void;
  onConfirm: (otp: string) => void;
}

const MFASetupFlow = ({ otpauthurl, secret, digits, onCancel, onConfirm }: Props) => {
  const { t } = useTranslation(["settings", "common"]);
  const [otp, setOtp] = useState("");

  return (
    <VStack gap="medium" alignItems="center" textAlign="center">
      <p className={css({ fontSize: "medium" })}>
        {t(($) => $.settings.mfa["Scan this QR code with your authenticator app or enter this secret key manually."])}
      </p>

      <QRCode value={otpauthurl} size={220} />

      <p className={css({ fontSize: "medium" })}>
        {t(($) => $.settings.mfa["Secret key:"])}
        <br />
        <Flex gap="small" justifyContent="center" alignItems="center">
          <strong>{secret}</strong>
          <Button
            variant="contentOnly"
            tooltip={t(($) => $.settings.mfa["Copy secret to clipboard"])}
            onPress={async () => {
              await navigator.clipboard.writeText(secret);
              successToast({ message: t(($) => $.settings.mfa["Secret copied"]) });
            }}
          >
            <FaCopy />
          </Button>
        </Flex>
      </p>
      <TextField
        label={t(($) => $.settings.mfa["{digits}-Digit Code"], { digits })}
        css={{ width: "150px" }}
        value={otp}
        onChange={setOtp}
        maxLength={digits}
        autoComplete="one-time-code"
        inputMode="numeric"
      />
      <Flex gap="xlarge" paddingY="medium">
        <Button variant="secondary" onPress={onCancel}>
          {t(($) => $.common.actions.Cancel)}
        </Button>

        <Button isDisabled={otp.length !== digits} onPress={() => onConfirm(otp)}>
          {t(($) => $.settings.mfa.Confirm)}
        </Button>
      </Flex>
    </VStack>
  );
};

export default MFASetupFlow;
